import { useInboundAllocationRequestCount } from '@hooks/other/useInboundAllocationRequests';
import { useInboundBurnRequests } from '@hooks/other/useInboundBurnRequests';
import { useInboundCommercialAgreementRequests } from '@hooks/other/useInboundCommercialAgreementRequests';
import { useInboundCredentialOffers } from '@hooks/other/useInboundCredentialOffers';
import { useInboundHolderServiceRequests } from '@hooks/other/useInboundHolderServiceRequests';
import { useInboundLockRequests } from '@hooks/other/useInboundLockRequests';
import { useInboundMintRequests } from '@hooks/other/useInboundMintRequests';
import { useInboundProviderServiceRequests } from '@hooks/other/useInboundProviderServiceRequests';
import { useInboundRegistrarServiceRequests } from '@hooks/other/useInboundRegistrarServiceRequests';
import { useInboundTransferOffers } from '@hooks/other/useInboundTransferOffers';
import { useReceivedUnlockOffers } from '@hooks/other/useReceivedUnlockOffers';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, Box, IconButton, Popover, Typography } from '@mui/material';
import { NotificationRow } from './NotificationRow';

export const Notifications: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const nav = useNavigate();
  // registry
  const transfers = useInboundTransferOffers();
  const allocations = useInboundAllocationRequestCount();
  const unlocks = useReceivedUnlockOffers();
  const burns = useInboundBurnRequests();
  const locks = useInboundLockRequests();
  const mints = useInboundMintRequests();
  // credentials
  const registrars = useInboundRegistrarServiceRequests();
  const providers = useInboundProviderServiceRequests();
  const holders = useInboundHolderServiceRequests();
  const credentials = useInboundCredentialOffers();
  // csa
  const csa = useInboundCommercialAgreementRequests();
  const showNotification =
    mints.length ||
    unlocks.length ||
    registrars.length ||
    providers.length ||
    holders.length ||
    credentials.length ||
    locks.length ||
    transfers.length ||
    allocations ||
    credentials.length ||
    csa.length;
  const goAllocations = () => {
    nav('/registry/allocationRequest');
  };
  const goMints = () => {
    nav('/registry/mints');
  };
  const goUnlocks = () => {
    nav('/registry/unlocks');
  };
  const goLocks = () => {
    nav('/registry/locks');
  };
  const goBurns = () => {
    nav('/registry/burns');
  };
  const goTransfers = () => {
    nav('/registry/transfers');
  };
  const goCredentials = () => {
    nav('/credential/offers');
  };
  const goCredentialOnboarding = () => {
    nav('/credential/onboarding');
  };
  const goCsa = () => {
    nav('/settings/commercial-agreements');
  };
  const notifications: { label: string; onClick: () => void; count: number }[] = [
    {
      label: 'Allocation requests',
      onClick: goAllocations,
      count: allocations,
    },
    {
      label: 'Mint requests',
      onClick: goMints,
      count: mints.length,
    },
    {
      label: 'Transfer requests',
      onClick: goTransfers,
      count: transfers.length,
    },
    {
      label: 'Credential offers',
      onClick: goCredentials,
      count: credentials.length,
    },
    {
      label: 'Unlock requests',
      onClick: goUnlocks,
      count: unlocks.length,
    },
    {
      label: 'Burn requests',
      onClick: goBurns,
      count: burns.length,
    },
    {
      label: 'Lock requests',
      onClick: goLocks,
      count: locks.length,
    },
    {
      label: 'registrar requests',
      onClick: goCredentialOnboarding,
      count: registrars.length,
    },
    {
      label: 'provider requests',
      onClick: goCredentialOnboarding,
      count: providers.length,
    },
    {
      label: 'holder requests',
      onClick: goCredentialOnboarding,
      count: holders.length,
    },
    {
      label: 'Commercial service agreement requests',
      onClick: goCsa,
      count: csa.length,
    },
  ];
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'notification-popover' : undefined;
  return (
    <>
      <IconButton
        aria-label="notifications"
        size="small"
        sx={{ display: 'flex', alignItems: 'center' }}
        onClick={handleClick}
      >
        <Badge
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          showZero
          variant="dot"
          color="error"
          invisible={!showNotification}
        >
          <NotificationsIcon fontSize="small" />
        </Badge>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box sx={{ p: 2, width: '300px' }}>
          {!showNotification && (
            <Typography variant="body2" sx={{ textAlign: 'center', p: 0 }}>
              No notifications
            </Typography>
          )}
          {notifications.map((n) => (
            <NotificationRow
              key={n.label}
              label={n.label}
              onClick={() => {
                n.onClick();
                handleClose();
              }}
              count={n.count}
            />
          ))}
        </Box>
      </Popover>
    </>
  );
};
